import type { Traducao } from '../tipos';

/** Textos de `relatorio`. Preenchido pela tradução da área — ver ../README.md. */
export const relatorio: Traducao = {
  pt: {
    cabecalho: {
      periodoUnico: '{{mes}} de {{ano}}',
      periodoDois: '{{mesA}} e {{mesB}} de {{ano}}',
      periodoFaixa: '{{mesA}} a {{mesB}} de {{ano}}',
      periodoAnos: '{{mesA}} de {{anoA}} a {{mesB}} de {{anoB}}',

      titulo: 'Relatório Mensal do Cliente',
      subtitulo: 'Visão executiva consolidada com indicadores, curva S e emissão oficial em PDF.',
      projeto: 'Projeto',
      emissao: 'Emissão',
    },
    filtro: {
      mesInicial: 'Mês inicial',
      mesFinal: 'Mês final (igual ao inicial = mês único)',
    },
    acao: {
      gerando: 'Gerando...',
      exportarOnePage: 'Exportar One Page',
      onePageSemanal: 'One Page Semanal',
      onePageTresSemanas: 'One Page 3 Semanas',
      exportarPdfCliente: 'Exportar PDF (Cliente)',
      exportarCronograma: 'Exportar cronograma',
      gerarPdf: 'Gerar PDF',
    },
    dica: {
      onePage: 'Exportar resumo executivo em uma única página',
      dataSemana: 'Data de referência para a semana (segunda a domingo)',
      onePageSemanal:
        'Exportar resumo executivo de uma única página para a semana (segunda a domingo) da data selecionada',
      onePageTresSemanas:
        'Montar e exportar o resumo de 3 semanas (anterior, atual e próxima — S-1, S e S+1), escolhendo os itens da próxima semana',
    },
    estado: {
      semProjeto: 'Selecione um projeto para gerar o relatório do cliente.',
      carregando: 'Carregando relatório...',
    },
    erro: {
      carregar: 'Não foi possível carregar o relatório mensal do cliente.',
      carregarInesperado: 'Erro ao carregar relatório mensal do cliente.',
      exportarPdf: 'Erro ao exportar PDF.',
      exportarOnePage: 'Erro ao exportar relatório One Page.',
      exportarCronograma: 'Erro ao exportar cronograma em Excel.',
      exportarOnePageSemanal: 'Erro ao exportar relatório One Page Semanal.',
      exportarTresSemanas: 'Erro ao exportar relatório One Page de 3 semanas.',
      escolhaDataSemana: 'Escolha uma data da semana desejada.',
      escolhaDataReferencia: 'Escolha uma data de referência (a semana do meio das 3).',
    },
    resumo: {
      titulo: 'Resumo Executivo',
    },
    indicadores: {
      titulo: '1. Indicadores',
      nota: 'Os indicadores refletem o mês atual e o mês seguinte.',
      planejado: 'Planejado',
      executado: 'Executado',
      desvio: 'Desvio',
      taxaExecucao: 'Taxa de execução',
    },
    curvaS: {
      titulo: '2. Curva S Planejado x Executado',
      mostrarAntigo: 'Mostrar cronograma antigo',
      hoje: 'Hoje',
      legendaPlanejadoAntigo: 'Planejado (cronograma antigo)',
    },
    pendencias: {
      titulo: '3. Pendências e atrasos',
      resumo: 'Total: {{total}} | Atrasadas: {{atrasadas}} | Sem vínculo: {{semVinculo}}',
      colTarefa: 'Tarefa',
      colPercentEfetivo: '% Efetivo',
      vazio: 'Sem pendências no período.',
    },
    areas: {
      titulo: '4. Status das Áreas',
      contagem: '{{total}} área(s)',
      vazio: 'Sem dados de área no período.',
      colConcluidas: 'Concluídas',
      colEmRevisao: 'Em revisão',
      colEmAndamento: 'Em andamento',
      colPendentes: 'Pendentes',
      colPercentConclusao: '% Conclusão',
    },
    hrn: {
      titulo: '5. Estratificação HRN',
      somenteNaoConformes: 'Somente não conformes',
      dicaSomenteNaoConformes: 'Mostrar apenas riscos não conformes',
      resumo: '{{riscos}} risco(s) · {{maquinas}} máquina(s)',
      vazioNaoConformes: 'Nenhum risco não conforme no período.',
      vazioAprovados: 'Nenhum documento aprovado.',
      semItens: 'Sem itens para exibir.',
      conforme: 'Conforme',
      naoConforme: 'Não conforme',
      colMaquina: 'Máquina',
      colParte: 'Parte',
      colHrns: 'HRNs (Classificação)',
      colConformidade: 'Conformidade',
      classificacao: {
        aceitavel: 'Aceitável',
        muitoBaixo: 'Muito baixo',
        baixo: 'Baixo',
        significante: 'Significante',
        alto: 'Alto',
        muitoAlto: 'Muito alto',
        extremo: 'Extremo',
        inaceitavel: 'Inaceitável',
      },
    },
    cronograma: {
      titulo: '6. Cronograma detalhado — {{periodo}}',
      colNivel: 'Nível',
      colTarefa: 'Tarefa',
      colInicio: 'Início',
      colTermino: 'Término',
      colPercentEfetivo: '% Efetivo',
      colEstado: 'Estado',
      vazio: 'Sem tarefas no período selecionado.',
      estadoNaoLevantada: 'Máquina não levantada',
    },
    modal: {
      titulo: 'Relatório de 3 semanas — Próxima semana',
      subtitulo:
        'Escolha os itens da próxima semana (S+1) e descreva cada um. Atrasados e pendências do período entram automaticamente no relatório.',
      buscarTarefa: 'Buscar tarefa do cronograma...',
      mostrarTodas: 'Mostrar todas as semanas (não só a próxima)',
      carregandoTarefas: 'Carregando tarefas...',
      semTarefas: 'Nenhuma tarefa encontrada.',
      semTarefasProxima: 'Nenhuma tarefa planejada para a próxima semana. Marque "Mostrar todas as semanas".',
      semanaAbrev: 'sem {{semana}}',
      atrasada: 'Atrasada',
      itens: 'Itens da próxima semana ({{quantidade}})',
      itemLivre: 'Item livre',
      vazio: 'Clique numa tarefa à esquerda para adicioná-la, e escreva a descrição que vai aparecer no relatório.',
      placeholderTitulo: 'Título do item',
      placeholderDescricao: 'Descrição do ponto (ex.: levantamento na coqueria — aguardando liberação da área)...',
      removerItem: 'Remover item',
      referencia: 'Referência: semana de {{data}} (S). O PDF cobre S-1, S e S+1.',
      categoria: {
        planejado: 'Planejado',
        atrasado: 'Atrasado',
        pendencia: 'Pendência',
      },
    },
  },
  en: {
    cabecalho: {
      periodoUnico: '{{mes}} {{ano}}',
      periodoDois: '{{mesA}} and {{mesB}} {{ano}}',
      periodoFaixa: '{{mesA}} to {{mesB}} {{ano}}',
      periodoAnos: '{{mesA}} {{anoA}} to {{mesB}} {{anoB}}',

      titulo: 'Monthly Client Report',
      subtitulo: 'Consolidated executive view with indicators, S-curve and official PDF issue.',
      projeto: 'Project',
      emissao: 'Issued on',
    },
    filtro: {
      mesInicial: 'Start month',
      mesFinal: 'End month (same as start = single month)',
    },
    acao: {
      gerando: 'Generating...',
      exportarOnePage: 'Export One Page',
      onePageSemanal: 'Weekly One Page',
      onePageTresSemanas: '3-Week One Page',
      exportarPdfCliente: 'Export PDF (Client)',
      exportarCronograma: 'Export schedule',
      gerarPdf: 'Generate PDF',
    },
    dica: {
      onePage: 'Export the executive summary on a single page',
      dataSemana: 'Reference date for the week (Monday to Sunday)',
      onePageSemanal:
        'Export the single-page executive summary for the week (Monday to Sunday) of the selected date',
      onePageTresSemanas:
        'Build and export the 3-week summary (previous, current and next — W-1, W and W+1), choosing the items for next week',
    },
    estado: {
      semProjeto: 'Select a project to generate the client report.',
      carregando: 'Loading report...',
    },
    erro: {
      carregar: 'Could not load the monthly client report.',
      carregarInesperado: 'Error loading the monthly client report.',
      exportarPdf: 'Error exporting the PDF.',
      exportarOnePage: 'Error exporting the One Page report.',
      exportarCronograma: 'Error exporting the schedule to Excel.',
      exportarOnePageSemanal: 'Error exporting the Weekly One Page report.',
      exportarTresSemanas: 'Error exporting the 3-week One Page report.',
      escolhaDataSemana: 'Choose a date within the week you want.',
      escolhaDataReferencia: 'Choose a reference date (the middle week of the 3).',
    },
    resumo: {
      titulo: 'Executive Summary',
    },
    indicadores: {
      titulo: '1. Indicators',
      nota: 'The indicators reflect the current month and the next month.',
      planejado: 'Planned',
      executado: 'Executed',
      desvio: 'Deviation',
      taxaExecucao: 'Execution rate',
    },
    curvaS: {
      titulo: '2. S-Curve Planned vs. Executed',
      mostrarAntigo: 'Show previous schedule',
      hoje: 'Today',
      legendaPlanejadoAntigo: 'Planned (previous schedule)',
    },
    pendencias: {
      titulo: '3. Open items and delays',
      resumo: 'Total: {{total}} | Overdue: {{atrasadas}} | Unlinked: {{semVinculo}}',
      colTarefa: 'Task',
      colPercentEfetivo: '% Effective',
      vazio: 'No open items in this period.',
    },
    areas: {
      titulo: '4. Area Status',
      contagem: '{{total}} area(s)',
      vazio: 'No area data in this period.',
      colConcluidas: 'Completed',
      colEmRevisao: 'Under review',
      colEmAndamento: 'In progress',
      colPendentes: 'Pending',
      colPercentConclusao: '% Completion',
    },
    hrn: {
      titulo: '5. HRN Stratification',
      somenteNaoConformes: 'Non-compliant only',
      dicaSomenteNaoConformes: 'Show only non-compliant risks',
      resumo: '{{riscos}} risk(s) · {{maquinas}} machine(s)',
      vazioNaoConformes: 'No non-compliant risk in this period.',
      vazioAprovados: 'No approved document.',
      semItens: 'No items to show.',
      conforme: 'Compliant',
      naoConforme: 'Non-compliant',
      colMaquina: 'Machine',
      colParte: 'Part',
      colHrns: 'HRNs (Classification)',
      colConformidade: 'Compliance',
      classificacao: {
        aceitavel: 'Acceptable',
        muitoBaixo: 'Very low',
        baixo: 'Low',
        significante: 'Significant',
        alto: 'High',
        muitoAlto: 'Very high',
        extremo: 'Extreme',
        inaceitavel: 'Unacceptable',
      },
    },
    cronograma: {
      titulo: '6. Detailed schedule — {{periodo}}',
      colNivel: 'Level',
      colTarefa: 'Task',
      colInicio: 'Start',
      colTermino: 'Finish',
      colPercentEfetivo: '% Effective',
      colEstado: 'State',
      vazio: 'No tasks in the selected period.',
      estadoNaoLevantada: 'Machine not surveyed',
    },
    modal: {
      titulo: '3-week report — Next week',
      subtitulo:
        'Choose the items for next week (W+1) and describe each one. Overdue and open items from the period go into the report automatically.',
      buscarTarefa: 'Search a schedule task...',
      mostrarTodas: 'Show every week (not just next week)',
      carregandoTarefas: 'Loading tasks...',
      semTarefas: 'No task found.',
      semTarefasProxima: 'No task planned for next week. Tick "Show every week".',
      semanaAbrev: 'wk {{semana}}',
      atrasada: 'Overdue',
      itens: 'Next week items ({{quantidade}})',
      itemLivre: 'Free item',
      vazio: 'Click a task on the left to add it, and write the description that will appear in the report.',
      placeholderTitulo: 'Item title',
      placeholderDescricao: 'Description of the point (e.g.: survey at the coke plant — waiting for the area release)...',
      removerItem: 'Remove item',
      referencia: 'Reference: week of {{data}} (W). The PDF covers W-1, W and W+1.',
      categoria: {
        planejado: 'Planned',
        atrasado: 'Overdue',
        pendencia: 'Open item',
      },
    },
  },
};
